// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

// Trix Editor
import "trix"
import "@rails/actiontext"
Trix.config.blockAttributes.heading1.tagName = "h2"

// Altcha Captcha
import "altcha"

// Snake Easter Egg
(function () {
    let inputBuffer = '';

    window.addEventListener('keydown', (e) => {
        if (['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) return;

        inputBuffer += e.key.toLowerCase();
        if (inputBuffer.length > 10) {
            inputBuffer = inputBuffer.slice(-10);
        }

        if (inputBuffer.includes('snake')) {
            window.location.href = '/snake';
        }
    });
})();